<progress *ngIf="type === 'default'" class="progress is-success" [ngStyle]="{height:height}" value="{{value}}"
    max="{{max}}"></progress>
<progress *ngIf="type === 'alert'" class="progress" [class.is-error]="value > max" [class.is-success]="value <= max"
    [ngStyle]="{height:height}" value="{{value}}" max="{{max}}"></progress>